export const ENROLLMENT_LIST = 'ENROLLMENT_LIST';
export const RE_ENROLLMENT_LIST = 'RE_ENROLLMENT_LIST';
export const SUPPRESSION_LIST = 'SUPPRESSION_LIST';
export const CLASSIC_GOAL_LIST = 'CLASSIC_GOAL_LIST';
export const SUPPRESSION_REMOVE_LIST = 'SUPPRESSION_REMOVE_LIST';
export const PERSISTED_RE_ENROLLMENT_LIST = 'PERSISTED_RE_ENROLLMENT_LIST';
export const REFINE_BY_LIST = 'REFINE_BY_LIST';